import { motion } from "framer-motion";
import { FileText } from "lucide-react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-stone-50" data-testid="terms-page">
      <Navbar />

      {/* Hero */}
      <section className="hero-bg pt-32 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 noise-overlay"></div>
        <div className="section-container relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-2xl"
          >
            <div className="w-16 h-16 bg-lime-400 rounded-2xl flex items-center justify-center mb-6">
              <FileText className="w-8 h-8 text-emerald-950" />
            </div>
            <h1 className="heading-2 text-white mb-4">Terms of Service</h1>
            <p className="body-lg text-stone-300">
              Terms and conditions for using Stack services.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="section-container py-16">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="prose prose-lg max-w-none"
          >
            <p className="text-stone-500 mb-8">Last updated: January 2024</p>

            <div className="space-y-8">
              <section>
                <h2 className="text-xl font-semibold text-emerald-950 mb-4">1. Acceptance of Terms</h2>
                <p className="text-stone-600 leading-relaxed">
                  By accessing or using Stack's services, you agree to be bound by these Terms of 
                  Service. If you do not agree to these terms, please do not use our services.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-emerald-950 mb-4">2. Services Description</h2>
                <p className="text-stone-600 leading-relaxed">
                  Stack provides on-demand cargo and grocery delivery services in Ontario, Canada. 
                  We connect customers with independent drivers and helpers who perform delivery services.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-emerald-950 mb-4">3. Independent Contractor Model</h2>
                <p className="text-stone-600 leading-relaxed">
                  Drivers and helpers who perform services through our platform are independent contractors, 
                  not employees of Stack. They are responsible for their own taxes, insurance, and 
                  compliance with applicable laws.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-emerald-950 mb-4">4. User Responsibilities</h2>
                <p className="text-stone-600 leading-relaxed">
                  Users must provide accurate information, ensure items are properly packaged, be present 
                  at pickup and delivery locations, and treat drivers and helpers with respect.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-emerald-950 mb-4">5. Prohibited Items</h2>
                <p className="text-stone-600 leading-relaxed">
                  The following items may not be shipped through Stack: hazardous materials, illegal 
                  substances, weapons, live animals, or any items prohibited by Canadian law.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-emerald-950 mb-4">6. Liability Limitations</h2>
                <p className="text-stone-600 leading-relaxed">
                  Stack's liability for loss or damage is limited to the coverage provided by our 
                  insurance policy. We are not liable for delays caused by circumstances beyond our control, 
                  including weather, traffic, or force majeure events.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-emerald-950 mb-4">7. Governing Law</h2>
                <p className="text-stone-600 leading-relaxed">
                  These Terms of Service are governed by the laws of the Province of Ontario and the 
                  federal laws of Canada applicable therein.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-emerald-950 mb-4">8. Contact Information</h2>
                <p className="text-stone-600 leading-relaxed">
                  For questions about these Terms, please contact us at legal@stackcart.ca.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPage;
